<template>
  <form @submit.prevent="submit" :novalidate="true">
    <b-card no-body v-bind:class="{ spinner: isBusy }">
      <b-tabs pills card>
        <template #tabs-end>
          <div class=" row align-items-center ms-auto">
            <label class="col-auto">
              {{ $t('Webportal.NotificationSettings.UseDefault') }}
              <font-awesome-icon :icon="['fas', 'lock']" />
            </label>
            <div class="col">
              <label class="switch switch-label switch-secondary">
                <input class="switch-input" type="checkbox"
                       v-model="isDefault"
                       v-validate data-vv-name="UseDefault">
                <span class="switch-slider" data-checked="On" data-unchecked="Off"></span>
              </label>
            </div>
          </div>
        </template>

        <b-tab :title="$t('Webportal.CheckReport')" active>
          <div v-if="checkReportNotification">
            <b-form-group
              :label-cols-sm="2"
              :label="$t('Webportal.Notification')"
              label-class="fw-bold pt-0"
              :disabled="isBusy || isDefault"
            >
              <b-form-checkbox
                v-model="checkReportNotification.NotifyOnNew"
                v-validate="'required'"
                data-vv-name="NotifyOnNewChecks"
              >
                {{ $t("Webportal.NotificationSettings.NotifyOnNewChecks") }}
              </b-form-checkbox>
              <b-form-checkbox
                v-model="checkReportNotification.NotifyOnModified"
                v-validate="'required'"
                data-vv-name="NotifyOnModifiedChecks"
              >
                {{
                  $t("Webportal.NotificationSettings.NotifyOnModifiedChecks")
                }}
              </b-form-checkbox>
            </b-form-group>

            <br />

            <b-form-group
              :label-cols-sm="2"
              :label="$t('Webportal.Schedule')"
              label-class="fw-bold pt-0"
            >
              <schedule-input
                v-model="checkReportNotification.CronScheduleUtc"
                v-validate="'required'"
                data-vv-name="CheckReportCronSchedule"
                :disabled="
                  isBusy || isDefault ||
                  (!checkReportNotification.NotifyOnNew &&
                    !checkReportNotification.NotifyOnModified)
                "
              />
            </b-form-group>
          </div>
        </b-tab>

        <b-tab
          :title="$t('Webportal.Actions.SurveyRevision')"
          v-if="userHasActionRevisePermission()"
        >
          <div v-if="checkRevisionNotification">
            <b-form-group
              :label-cols-sm="2"
              :label="$t('Webportal.Notification')"
              label-class="fw-bold pt-0"
              :disabled="isBusy || isDefault"
            >
              <b-form-checkbox
                v-model="checkRevisionNotification.NotifyOnNew"
                v-validate="'required'"
                data-vv-name="NotifyOnNewCheckRevisions"
              >
                {{
                  $t("Webportal.NotificationSettings.NotifyOnNewCheckRevisions")
                }}
              </b-form-checkbox>
              <b-form-checkbox
                v-model="checkRevisionNotification.NotifyOnModified"
                v-validate="'required'"
                data-vv-name="NotifyOnModifiedCheckRevisions"
              >
                {{
                  $t(
                    "Webportal.NotificationSettings.NotifyOnModifiedCheckRevisions"
                  )
                }}
              </b-form-checkbox>
            </b-form-group>

            <br />

            <b-form-group
              :label-cols-sm="2"
              :label="$t('Webportal.Schedule')"
              label-class="fw-bold pt-0"
            >
              <schedule-input
                v-model="checkRevisionNotification.CronScheduleUtc"
                v-validate="'required'"
                data-vv-name="CheckRevisionCronSchedule"
                :disabled="
                  isBusy || isDefault ||
                  (!checkRevisionNotification.NotifyOnNew &&
                    !checkRevisionNotification.NotifyOnModified)
                "
              />
            </b-form-group>
          </div>
        </b-tab>

        <b-tab
          :title="$t('Webportal.Actions.SurveyImprovement')"
          v-if="userHasActionImprovementPermission()"
        >
          <div v-if="checkImprovementNotification">
            <b-form-group
              :label-cols-sm="2"
              :label="$t('Webportal.Notification')"
              label-class="fw-bold pt-0"
              :disabled="isBusy || isDefault"
            >
              <b-form-checkbox
                v-model="checkImprovementNotification.NotifyOnActionsToTake"
                v-validate="'required'"
                data-vv-name="NotifyOnActionsToTakeCheckImprovements"
              >
                {{
                  $t("Webportal.NotificationSettings.NotifyOnActionsToTakeCheckImprovements")
                }}
              </b-form-checkbox>
              <b-form-checkbox
                v-model="checkImprovementNotification.NotifyOnNew"
                v-validate="'required'"
                data-vv-name="NotifyOnNewCheckImprovements"
              >
                {{
                  $t("Webportal.NotificationSettings.NotifyOnNewCheckImprovements")
                }}
              </b-form-checkbox>
              <b-form-checkbox
                v-model="checkImprovementNotification.NotifyOnModified"
                v-validate="'required'"
                data-vv-name="NotifyOnModifiedCheckImprovements"
              >
                {{
                  $t(
                    "Webportal.NotificationSettings.NotifyOnModifiedCheckImprovements"
                  )
                }}
              </b-form-checkbox>
            </b-form-group>

            <br />

            <b-form-group
              :label-cols-sm="2"
              :label="$t('Webportal.Schedule')"
              label-class="fw-bold pt-0"
            >
              <schedule-input
                v-model="checkImprovementNotification.CronScheduleUtc"
                v-validate="'required'"
                data-vv-name="CheckImprovementCronSchedule"
                :disabled="
                  isBusy || isDefault ||
                  (!checkImprovementNotification.NotifyOnActionsToTake &&
                   !checkImprovementNotification.NotifyOnNew &&
                   !checkImprovementNotification.NotifyOnModified)
                "
              />
            </b-form-group>
          </div>
        </b-tab>
      </b-tabs>

      <template v-slot:footer>
        <div class="float-end">
          <button
            @click.prevent="cancel"
            class="btn btn-secondary"
            :disabled="!isFormChanged || isBusy"
          >
            <font-awesome-icon :icon="['far', 'ban']" />
            {{ $t("Webportal.Cancel") }}
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            :disabled="!isFormChanged || !isFormValid || isBusy"
          >
            <font-awesome-icon :icon="['far', 'dot-circle']" />
            {{ $t("Webportal.Save") }}
          </button>
        </div>
      </template>
    </b-card>
  </form>
</template>

<script>
import AppConfig from "@/mixins/AppConfig-APP_TARGET";
import ScheduleInput from "@/components/ScheduleInput";
import UsersService from "@/services/UsersService";
import SurveyRevisionMixin from "@/mixins/SurveyRevisionMixin";
import SurveyImprovementMixin from "@/mixins/SurveyImprovementMixin";

import useVuelidate from '@vuelidate/core';
import { required, email, helpers } from '@vuelidate/validators';

export default {
  name: "NotificationSettings",

  mixins: [ AppConfig, SurveyRevisionMixin, SurveyImprovementMixin ],

  components: {
    ScheduleInput,
  },

  setup () {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      checkReportNotification: null,
      checkRevisionNotification: null,
      checkImprovementNotification: null,

      defaultNotifications: [],

      isBusy: false,
    };
  },

  mounted() {
    this.initializeTheme();
  },

  computed: {
    isFormChanged() {
      return this.v$.$anyDirty;
    },

    isFormValid() {
      return !this.v$.$error || this.v$.$anyDirty;
    },

    isDefault: {
      get: function() {
        return this.checkReportNotification?.IsDefault || this.checkRevisionNotification?.IsDefault;
      },
      set: function(newValue) {
        this.checkReportNotification.IsDefault = newValue;
        this.checkRevisionNotification.IsDefault = newValue;
        this.checkImprovementNotification.IsDefault = newValue;

        if (newValue)
        {
          let defaultCheckReport = this.defaultNotifications.find(n => n.Name === 'Check Reports');
          this.checkReportNotification.NotificationTypeId = defaultCheckReport?.NotificationTypeId;
          this.checkReportNotification.CronScheduleUtc = defaultCheckReport?.CronScheduleUtc;
          this.checkReportNotification.NotifyOnNew = defaultCheckReport?.WorkflowEventIds.includes(1) ?? false;
          this.checkReportNotification.NotifyOnModified = defaultCheckReport?.WorkflowEventIds.includes(2) ?? false;

          let defaultCheckRevision = this.defaultNotifications.find(n => n.Name === 'Check Revisions');
          this.checkRevisionNotification.NotificationTypeId = defaultCheckRevision?.NotificationTypeId;
          this.checkRevisionNotification.CronScheduleUtc = defaultCheckRevision?.CronScheduleUtc;
          this.checkRevisionNotification.NotifyOnNew = defaultCheckRevision?.WorkflowEventIds.includes(11) ?? false;
          this.checkRevisionNotification.NotifyOnModified = defaultCheckRevision?.WorkflowEventIds.includes(12) ?? false;

          let defaultCheckImprovement = this.defaultNotifications.find(n => n.Name === 'Check Improvements');
          this.checkImprovementNotification.NotificationTypeId = defaultCheckImprovement?.NotificationTypeId;
          this.checkImprovementNotification.CronScheduleUtc = defaultCheckImprovement?.CronScheduleUtc;
          this.checkImprovementNotification.NotifyOnActionsToTake = defaultCheckImprovement?.WorkflowEventIds.includes(20) ?? false;
          this.checkImprovementNotification.NotifyOnNew = defaultCheckImprovement?.WorkflowEventIds.includes(21) ?? false;
          this.checkImprovementNotification.NotifyOnModified = defaultCheckImprovement?.WorkflowEventIds.includes(22) ?? false;
        }
      }
    },

    notificationData() {
      return [
        {
          Name: "Check Reports",
          IsDefault: this.checkReportNotification.IsDefault,
          NotificationTypeId: 1, // Mail
          CronScheduleUtc: this.checkReportNotification.CronScheduleUtc,
          Subscription: {
            WorkflowEventIds: [
              ...(this.checkReportNotification.NotifyOnNew ? [1] : []),
              ...(this.checkReportNotification.NotifyOnModified ? [2] : []),
            ],
          },
        },

        {
          Name: "Check Revisions",
          IsDefault: this.checkRevisionNotification.IsDefault,
          NotificationTypeId: 1, // Mail
          CronScheduleUtc: this.checkRevisionNotification.CronScheduleUtc,
          Subscription: {
            WorkflowEventIds: [
              ...(this.checkRevisionNotification.NotifyOnNew ? [11] : []),
              ...(this.checkRevisionNotification.NotifyOnModified ? [12] : []),
            ],
          },
        },

        {
          Name: "Check Improvements",
          IsDefault: this.checkImprovementNotification.IsDefault,
          NotificationTypeId: 1, // Mail
          CronScheduleUtc: this.checkImprovementNotification.CronScheduleUtc,
          Subscription: {
            WorkflowEventIds: [
              ...(this.checkImprovementNotification.NotifyOnActionsToTake ? [20] : []),
              ...(this.checkImprovementNotification.NotifyOnNew ? [21] : []),
              ...(this.checkImprovementNotification.NotifyOnModified ? [22] : []),
            ],
          },
        }
      ];
    },
  },

  activated() {
    this.getNotificationSettings();
  },

  beforeRouteLeave(to, from, next) {
    this.$emit("unsavedChanges", this.isFormChanged, next);
  },

  methods: {
    getNotificationSettings() {
      this.isBusy = true;

      UsersService.getUserProfile()
        .then((response) => {
          this.isBusy = false;

          this.defaultNotifications = response.data.DefaultNotifications ?? [];

          const notificationData =
            response && response.data ? response.data.Notifications : null;

          let notification = notificationData?.find(
            (nd) => nd.Name === "Check Reports"
          );
          this.checkReportNotification = {
            IsDefault: notification?.IsDefault ?? false,
            NotifyOnNew: notification?.Subscription.WorkflowEventIds.includes(1) ?? false,
            NotifyOnModified: notification?.Subscription.WorkflowEventIds.includes(2) ?? false,
            CronScheduleUtc: notification?.CronScheduleUtc,
          };

          notification = notificationData?.find(
            (nd) => nd.Name === "Check Revisions"
          );
          this.checkRevisionNotification = {
            IsDefault: notification?.IsDefault ?? false,
            NotifyOnNew: notification?.Subscription.WorkflowEventIds.includes(11) ?? false,
            NotifyOnModified: notification?.Subscription.WorkflowEventIds.includes(12) ?? false,
            CronScheduleUtc: notification?.CronScheduleUtc,
          };

          notification = notificationData?.find(
            (nd) => nd.Name === "Check Improvements"
          );
          this.checkImprovementNotification = {
            IsDefault: notification?.IsDefault ?? false,
            NotifyOnActionsToTake: notification?.Subscription.WorkflowEventIds.includes(20) ?? false,
            NotifyOnNew: notification?.Subscription.WorkflowEventIds.includes(21) ?? false,
            NotifyOnModified: notification?.Subscription.WorkflowEventIds.includes(22) ?? false,
            CronScheduleUtc: notification?.CronScheduleUtc,
          };

          this.v$.$reset();
        })
        .finally((_) => {
          this.isBusy = false;
        });
    },

    cancel() {
      this.$emit("unsavedChanges", this.isFormChanged, (result) => {
        if (result !== false) this.getNotificationSettings();
      });
    },

    submit() {
      this.isBusy = true;

      UsersService.setUserProfile({ Notifications: this.notificationData })
        .then((response) => {
          this.v$.$reset();
        })
        .finally((_) => {
          this.isBusy = false;
        });
    },
  },
};
</script>
<style scoped>
/* Workaround: Overwrite base style in _nav.scss */
.tabs >>> .tab-content {
  border: 0;
}
</style>
